// extracted by mini-css-extract-plugin
export default {"Container":"SingleCheckbox_Container__dOVoh","Input":"SingleCheckbox_Input__U1998"};